<template>
    <div class="book-search">
        <div class="slts">
            <div class="slt">
                <a-checkbox :indeterminate="indeterminate1" :checked="checkAll1" @change="onCheckAllChange1">
                    所有资源
                </a-checkbox>
            </div>
            <a-checkbox-group v-model="checkedList1" @change="onChange1">
                <div class="slt">
                    <a-checkbox value="newspaper" :disabled="newspaperDisabled">
                        报
                    </a-checkbox>
                </div>
                <div class="slt">
                    <a-checkbox value="magazine" :disabled="magazineDisabled">
                        刊
                    </a-checkbox>
                </div>
            </a-checkbox-group>
        </div>
        <div class="slts">
            <div class="slt">
                <a-checkbox :indeterminate="indeterminate2" :checked="checkAll2" @change="onCheckAllChange2">
                    全部类型
                </a-checkbox>
            </div>
            <a-checkbox-group v-model="checkedList2" @change="onChange2">
                <div class="slt">
                    <a-checkbox value="Article" :disabled="ArticleDisabled">
                        正文
                    </a-checkbox>
                </div>
                <div class="slt">
                    <a-checkbox value="Advertisement" :disabled="AdvertisementDisabled">
                        广告
                    </a-checkbox>
                </div>
                <div class="slt">
                    <a-checkbox value="Picture" :disabled="PictureDisabled">
                        图片
                    </a-checkbox>
                </div>
            </a-checkbox-group>
        </div>
        <div class="ipts">
            <div class="ipt" v-for="(f, index) in filters" :key="index">
                <a href="javascript:" class="add" @click="addFilter(index)">{{index === 0 ? '+' : '-'}}</a>
                <select class="s1" v-model="f.logic" :style="index==0?'visibility: hidden;' : ''">
                    <!-- <option selected disabled>与</option> -->
                    <option value="and" >与</option>
                    <option value="or"  >或</option>
                    <option value="not" >非</option>
                </select>
                <select class="s2" v-model="f.field">
                    <!-- <option selected disabled>提名</option> -->
                    <option value="TI">题名</option>
                    <option value="CO">作者</option>
                    <option value="LM">栏目</option>
                </select>
                <input class="s3" type="text" placeholder="检索词" v-model="f.value"  @keyup.enter="advancedsearch">
                <select class="s4" v-model="f.type">
                    <!-- <option selected disabled>模糊</option> -->
                    <option value="0" >模糊</option>
                    <option value="1" >精确</option>
                </select>
            </div>
        </div>
        <div class="sell-date">
            <div class="lb">
                <p><a-checkbox :defaultChecked="true" @change="sjChange">出版时间</a-checkbox></p>
                <a-slider :min="1800" :max="2020" range v-model="range" />
            </div>
            <div class="date-pk">
                <!--  :value="range[0]" :value="range[1]"  -->
                <!-- precision: 数值精度（小数位） -->
                <a-input-number :precision="0" :min="minPrev" :max="rangeNext" :disabled="false" v-model="rangePrev"/>
                ~
                <a-input-number :precision="0" :min="rangePrev" :max="maxNext" :disabled="false" v-model="rangeNext"/>
            </div>
        </div>
        <div class="btns">
            <a href="javascript:" class="reset" @click="reset">重置</a>
            <a href="javascript:" class="search" @click="advancedsearch">检索</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isParentSearch:{
            detail:false
        }
    },
    data(){
        return{
            filters:[
                {
                    logic:'and',
                    field:'TI',
                    value:'',
                    type :'0'
                },
                {
                    logic:'and',
                    field:'CO',
                    value:'',
                    type :'0'
                },
                {
                    logic:'and',
                    field:'LM',
                    value:'',
                    type :'0'
                }
            ],
            // range:[1800, 2020],
            rangePrev: 1800,
            rangeNext: 2000,
            minPrev: 1800, // 默认最小年份
            maxNext: 2020, // 默认最大年份
            indeterminate1: false, // 所有资源选中状态
            sjChecked: true,       // 出版时间勾选状态
            checkAll1: true,       // 所有资源全选
            checkedList1: ['newspaper', 'magazine'], // 所有资源选中数据
            plainOptions1:['newspaper', 'magazine'], // 所有资源全部数据
            lastChecked1: '',      // 最后一个被勾中的资源
            indeterminate2: false, // 全部类型选中状态
            checkAll2: true,       // 全部类型全选
            checkedList2: ['Article', 'Advertisement', 'Picture'], // 全部类型选中数据
            plainOptions2:['Article', 'Advertisement', 'Picture'], // 全部类型全部数据
            lastChecked2: '',      // 最后一个被勾中的类型
            newspaperDisabled    : false,   // 报失效状态
            magazineDisabled     : false,   // 刊失效状态
            ArticleDisabled      : false,   // 正文失效状态
            AdvertisementDisabled: false,   // 广告失效状态
            PictureDisabled      : false,   // 图片失效状态
        }
    },
    computed: {
        range: {
            // getter
            get: function () {
                let defaulRange = [this.rangePrev, this.rangeNext];
                return defaulRange;
            },
            // setter
            set: function (newValue) {
                this.rangePrev = newValue[0];
                this.rangeNext = newValue[1];
            }
        },
        publicTime(){
            return [
                {
                    logic:'and',
                    field:'SJ',
                    value:this.rangePrev,
                    type :'2'
                },
                {
                    logic:'and',
                    field:'SJ',
                    value:this.rangeNext,
                    type :'3'
                }
            ]
        }
    },
    watch:{
        rangePrev:function(){
            if(this.rangePrev > this.rangeNext) this.rangePrev = this.minPrev;
        },
        rangeNext:function(){
            if(this.rangePrev > this.rangeNext) this.rangeNext = this.maxNext;
        }
    },
    methods:{
        advancedsearch(){ // 高级检索-文献检索
            let _searchType = 2;
            let _newarr = [];
            if(this.sjChecked) _newarr = this.publicTime.concat(this.filters);
            else _newarr = this.filters.concat([]);
            _newarr = this.removePropEmpty(_newarr, 'value');
            // let _newarr = this.removePropEmpty(this.filters, 'value');
            // 复选框勾选值，防止在列表页清除检索条件的同时把高级检索的样式清理了
            let _sourceTypes = this.checkedList1.concat([]);
            let _types       = this.checkedList2.concat([]);
            let advancedParams = {
                searchType  : _searchType,
                sourceTypes : _sourceTypes,
                types       : _types,
                advancedCdtn: _newarr
            }
            if(this.isParentSearch) this.$emit('advancedsearch2', advancedParams);
            else this.$router.push({
                name:"bkSearchResult",
                params:{ 
                    searchType: _searchType, 
                    advancedParams: JSON.stringify(advancedParams) 
                }
            });
        },
        sjChange(e){ // 出版时间
            this.sjChecked = e.target.checked;
        },
        onChange1(checkedList) {
            // this.indeterminate1 = !!checkedList.length && checkedList.length < this.plainOptions1.length;
            this.checkAll1 = checkedList.length === this.plainOptions1.length;

            // 至少勾选一项资源
            if(checkedList.length == 1) this.lastChecked1 = checkedList[0];
            if(checkedList.length <= 0){
                let _disabled = this.lastChecked1 + 'Disabled';
                this[_disabled] = true;
                this.checkedList1 = [this.lastChecked1];
                this.$message.warning('请至少勾选一项资源！', 1);
            }
            else {
                for(let i=0; i<this.plainOptions1.length; i++) {
                    let _disabled = this.plainOptions1[i] + 'Disabled';
                    this[_disabled] = false;
                }
            }
        },
        onCheckAllChange1(e) {
            Object.assign(this, {
                checkedList1    : e.target.checked ? this.plainOptions1 : [],
                indeterminate1  : false,
                checkAll1       : e.target.checked,
            });

            // 至少勾选一项资源
            if(e.target.checked) {
                for(let i=0; i<this.plainOptions1.length; i++) {
                    let _disabled = this.plainOptions1[i] + 'Disabled';
                    this[_disabled] = false;
                }
            }
            else {
                let _disabled = this.plainOptions1[0] + 'Disabled';
                this[_disabled] = true;
                this.checkedList1 = [this.plainOptions1[0]];
                this.$message.warning('请至少勾选一项资源！', 1);
            }
        },
        onChange2(checkedList) {
            // this.indeterminate2 = !!checkedList.length && checkedList.length < this.plainOptions2.length;
            this.checkAll2 = checkedList.length === this.plainOptions2.length;

            // 至少勾选一项资源
            if(checkedList.length == 1) this.lastChecked2 = checkedList[0];
            if(checkedList.length <= 0){
                let _disabled = this.lastChecked2 + 'Disabled';
                this[_disabled] = true;
                this.checkedList2 = [this.lastChecked2];
                this.$message.warning('请至少勾选一项类型！', 1);
            }
            else {
                for(let i=0; i<this.plainOptions2.length; i++) {
                    let _disabled = this.plainOptions2[i] + 'Disabled';
                    this[_disabled] = false;
                }
            }
        },
        onCheckAllChange2(e) {
            Object.assign(this, {
                checkedList2    : e.target.checked ? this.plainOptions2 : [],
                indeterminate2  : false,
                checkAll2       : e.target.checked,
            });

            // 至少勾选一项资源
            if(e.target.checked) {
                for(let i=0; i<this.plainOptions2.length; i++) {
                    let _disabled = this.plainOptions1[i] + 'Disabled';
                    this[_disabled] = false;
                }
            }
            else {
                let _disabled = this.plainOptions2[0] + 'Disabled';
                this[_disabled] = true;
                this.checkedList2 = [this.plainOptions2[0]];
                this.$message.warning('请至少勾选一项类型！', 1);
            }
        },
        addFilter(index){
            if(index === 0){
                if(this.filters.length > 9){
                    return
                }
                this.filters.push({
                    logic:'and',
                    field:'TI',
                    value:'',
                    type :'0'
                })
            } else {
                this.filters.splice(index, 1)
            }
        },
        reset(){
            this.clear(); // 复选框恢复默认
            this.range = [1800, 2000];
            this.filters.filter((item, index) => {
                item.logic = 'and';
                item.value = '';
                item.type  = '0';
                switch (index) {
                    case 0:
                        item.field = 'TI';
                        break;
                    case 1:
                        item.field = 'CO';
                        break;
                    case 2:
                        item.field = 'LM';
                        break;
                    default:
                        item.field = 'TI';
                        break;
                }
            });
        },
        clear(){
            this.indeterminate1 = false;
            this.indeterminate2 = false;
            this.checkAll1 = true;
            this.checkAll2 = true;
            this.checkedList1 = this.plainOptions1; // 所有资源选中数据
            this.checkedList2 = this.plainOptions2; // 全部类型选中数据
        }
    }
}

</script>


<style scoped lang="less">
    /deep/ .ant-slider-track{
        background: #1473a5;
        &:hover{
            background: #1473a5;
        }
    }
    /deep/ .ant-slider{
        margin-top: 5px;
    }
    .book-search { // 高级检索，高度限制，若超出则出现滚动条
        .slts{
            margin-bottom: auto!important;
            max-width: none!important;
        }
        .ipts{
            overflow-y: auto!important;
            max-height: 240px;
            
            // 滚动条样式
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                -webkit-box-shadow: inset 0 0 5px rgba(51,75,135, 0.6);
                box-shadow: inset 0 0 5px rgba(51,75,135, 0.6);
                background: rgba(51,75,135, 0.6);
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 5px rgba(51,75,135, 0.4);
                box-shadow: inset 0 0 5px rgba(51,75,135, 0.4);
                border-radius: 5px;
                background: rgba(51,75,135, 0.2);
            }
        }
    }

    // 复选框禁用状态下样式
    /deep/.ant-checkbox-disabled{
        cursor: pointer!important;
        .ant-checkbox-inner{
            border: 1px solid #666 !important;
            cursor: pointer!important;
        }
    }
    /deep/.ant-checkbox-disabled + span{
        color: inherit;
        cursor: pointer!important;
    }
    /deep/.ant-checkbox-wrapper{
        &.ant-checkbox-wrapper-disabled{
            cursor: pointer!important;
        }
    }
</style>
